import Vue from 'vue';
import Router from 'vue-router';
import Top from '@/_routers/top.vue';
import About from '@/_routers/about.vue';
import Recruit from '@/_routers/recruit.vue';
import Works from '@/_routers/works.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'top',
      component: Top,
      meta: {
        title: 'Slanted|スランテッド',
        desc: 'slanted”は山内太・山藤真士が代表を務めるCGスペシャリストユニットです。自動車のCG映像・フォト制作を中核に、DNAグループとのシナジーを活かし、今後はより幅広い領域に活動を広げていきます。',
      }
      //component: loadView('Top'), // TODO: 初期ロードの負荷を抑えるためにWebpackのCode Splittingを用いたDynamic Import
    },
    {
      path: '/works/:id',
      name: 'works',
      component: Works,
      meta: {
        title: 'WORKS|Slanted|スランテッド',
        desc: 'SlantedのWORKSページです。',
      }
      //component: loadView('Works'),
    },
    {
      path: '/about/',
      name: 'about',
      component: About,
      meta: {
        title: 'ABOUT|Slanted|スランテッド',
        desc: '他に埋もれることのない独自の表現を大切にしたモノづくり、これがslantedの理念です。',
      }
      //component: loadView('About'),
    },
    {
      path: '/recruit/',
      name: 'recruit',
      component: Recruit,
      meta: {
        title: 'RECRUIT|Slanted|スランテッド',
        desc: 'よりクリエイティブな仕事を目指したい方、是非ご応募ください。',
      }
      //component: loadView('Recruit'),
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // 画面遷移後のスクロール制御
    if (savedPosition) {
      return savedPosition
    }
    /*
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
    */
  }
});